require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-giornate-europee-del-patrimonio-or-senza-frontiere-8-9-settembre-2018.json") })
        }
      }, "path---relazioni-e-conferenze-giornate-europee-del-patrimonio-or-senza-frontiere-8-9-settembre-2018");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-giornate-europee-del-patrimonio-or-senza-frontiere-8-9-settembre-2018!./.cache/json/relazioni-e-conferenze-giornate-europee-del-patrimonio-or-senza-frontiere-8-9-settembre-2018.json
// module id = 697
// module chunks = 231608221292675